import { push } from "svelte-spa-router";
import { baseApiUrl, loginStoreKey } from "../constants";
import { examProgress, loggedIn, questions, userIsApproved, userProfile, userProgress } from "../stores";
import { demoSvc } from "./demo.service";
import { helpersSvc } from "./helpers.service";

class AuthService {
  async verifyAuthData() {
    const authData = this.getAuthData();
    if (authData && await this.validate()) {
      await this.setAuthData(authData);
    }
  }
  getAuthData() {
    let authData;
    try {
      authData = JSON.parse(window.localStorage.getItem(loginStoreKey));
    } catch (error) {
      push('/error-security');
    }
    return authData;
  }
  getToken() {
    return this.getAuthData()?.token;
  }
  clearAuthData() {
    try {
      localStorage.removeItem(loginStoreKey);
    } catch (error) {
      push('/error-security');
    }
  }
  async setAuthData(authData) {
    loggedIn.set(authData);
    try {
      localStorage.setItem(loginStoreKey, JSON.stringify(authData));
    } catch (error) {
      push('/error-security');
    }
    // await this.setUserProgress({"success":{"userprogress":{"chapters":{"abschlag":{"status":"success","videoPlayed":true,"rulesRead":{"0":true,"1":true,"2":true}}}},"_up_type":"object"}}); console.warn('====> Resetting userProgress');
    await this.fetchUserProgress();
  }
  _getHeaders() {
    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.getToken()}`
    };
  }
  async login(userdata) {
    const jwtResponse = await fetch(baseApiUrl + 'jwt-auth/v1/token', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: userdata.email,
        password: userdata.password
      })
    });
    const result = await jwtResponse.json();
    // .success = altes auth plugin, .token = neues auth plugin
    if (!result.success && !result.token) {
      const error = result.statusCode == 403 ? result.message.replace('Passwort vergessen?', '<a href="/wp/wp-login.php?action=lostpassword">Passwort vergessen?</a>') : result.message;
      return { error };
    }
    await this.setAuthData(result);
    return { success: result };
  }
  async validate() {
    const jwtResponse = await fetch(baseApiUrl + 'jwt-auth/v1/token/validate', {
      method: 'POST',
      headers: this._getHeaders()
    });
    const result = await jwtResponse.json();
    if(result.code === 'jwt_auth_valid_credential') {
      return true;
    }
    this.clearAuthData();
    return false;
  }
  async register(userdata) {
    const rawResponse = await fetch(baseApiUrl + 'begolf/v1/register', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(userdata)
    });
    const result = await rawResponse.json();
    // console.log('Register', userdata, result);
    return result.success ? { success: result.success } : { error: result.message || result.error };
  }
  async logout() {
    if (!this.getToken()) {
      return;
    }
    await fetch(baseApiUrl + 'begolf/v1/logout', { method: 'POST', headers: this._getHeaders()});
    this.clearAuthData();
  }
  async fetchUserProgress() {
    if (!this.getToken()) {
      return;
    }
    const response = await fetch(baseApiUrl + 'begolf/v1/userprogress', { method: 'GET', headers: this._getHeaders()});
    const result = await response.json();
    if (result.code) {
      console.error('fetchUserProgress error', result.code);
      return;
    }
    let up = result.success.userprogress;
    try {
      up = JSON.parse(up);
    } catch (_) {}
    examProgress.set(result.success.examprogress);
    userIsApproved.set(result.success.userapproved);
    userProgress.set(up);
    userProfile.set(result.success.userprofile);
  }
  async getChapters() {
    const response = await fetch(baseApiUrl + 'begolf/v1/chapters', { method: 'GET', headers: this.getToken() ? this._getHeaders(): {}});
    const result = await response.json();
    if (result.code) {
      console.error('getChapters error', result.code);
      return;
    }
    let chapters = result.success;
    try {
      chapters = JSON.parse(chapters);
    } catch (_) {}
    return chapters;
  }
  async setUserQuestions(slug = false) {
    if (!slug) {
      return;
    }
    if (demoSvc.isDemoInstance()) {
      return demoSvc.getQuestions();
    }
    const response = await fetch(baseApiUrl + 'begolf/v1/userquestions/' + slug, { method: 'GET', headers: this._getHeaders()});
    const result = await response.json();
    if (result.code || result.error) {
      console.error('setUserQuestions', result.code || result.error);
      return;
    }
    const qs = result.success;
    if (!qs.length) {
      questions.set([]);
    } else if (qs[0].fields) {
      questions.set(mappingSvc.mapQuestions(qs));
    } else {
      questions.set(result.success);
    }
  }
  async storeUserProgress(up) {
    if (!this.getToken()) {
      return;
    }
    
    this.newUp = up;

    if (!this.isStoring) {
      this.isStoring = true;
      setTimeout(async() => {
        // console.log('setUserProgress storing', helpersSvc.clone(up));
        await fetch(baseApiUrl + 'begolf/v1/userprogress', { method: 'POST',
          body: JSON.stringify({
            userprogress: JSON.stringify(this.newUp)
          }),
          headers: this._getHeaders()
        });
        this.isStoring = false;
      }, 250);
    }
  }

  async storeQuestionsProgress(qp, slug) {
    if (!this.getToken() || !slug) {
      return;
    }

    this.newQp = helpersSvc.clone(qp);

    if (!this.isStoringQp) {
      this.isStoringQp = true;
      setTimeout(async() => {
        await fetch(baseApiUrl + 'begolf/v1/userquestions/' + slug, { method: 'POST',
          body: JSON.stringify({
            questions: JSON.stringify(this.newQp)
          }),
          headers: this._getHeaders()
        });
        this.isStoringQp = false;
      }, 250);
    }
  }
}
export const authSvc = new AuthService();